import { Input } from '@aigc/antd';
import type { Lens } from '@hookform/lenses';
import { useFieldArray } from '@hookform/lenses/rhf';
import { Form, Mentions, Table, Typography } from 'antd';
import { FormControl } from '../../../components/form-control';
import type { FileInputDto } from '../../file/model';
import { buildImageMentionOptions } from '../../video-model/image-mention-utils';
import type { ProductAnalysisShotDto, ProductScriptFormValues } from '../model';

export function ProductScriptTable(props: {
  shots: ProductAnalysisShotDto[];
  lens: Lens<ProductScriptFormValues['shots']>;
  productImages: FileInputDto[];
}) {
  const { fields } = useFieldArray(props.lens.interop());

  return (
    <Table
      size="middle"
      tableLayout="fixed"
      scroll={{ x: 800 }}
      dataSource={fields}
      rowKey={(row) => row.id}
      showHeader={false}
      columns={[
        {
          render: (_, __, index) => {
            const shot = props.shots[index];
            const shot_lens = props.lens.focus(index);

            return (
              <Form
                layout="vertical"
                className="grid grid-cols-1 gap-x-4 lg:grid-cols-2"
              >
                <FormControl
                  {...shot_lens.focus('script').interop()}
                  label={
                    <>
                      镜号 {shot?.shot_index ?? index + 1} · 脚本， 支持通过输入
                      <Typography.Text keyboard>@</Typography.Text>
                      字符来引用图片，例如
                      <Typography.Text code>@图片1</Typography.Text>
                    </>
                  }
                  required
                  render={({ field }) => (
                    <Mentions
                      {...field}
                      options={buildImageMentionOptions(
                        props.productImages.map(() => ({ disabled: false })),
                      )}
                      autoSize={{ minRows: 10, maxRows: 20 }}
                      placeholder="请输入脚本，可通过 @ 引用产品图"
                    />
                  )}
                />
                <FormControl
                  {...shot_lens.focus('image_instructions').interop()}
                  label={`镜号 ${shot?.shot_index ?? index + 1} · 生图指令`}
                  render={({ field }) => (
                    <Input.TextArea
                      {...field}
                      autoSize={{ minRows: 10, maxRows: 20 }}
                      placeholder="请输入生图指令"
                    />
                  )}
                />
              </Form>
            );
          },
        },
      ]}
      pagination={false}
    />
  );
}
